import React, { useState } from "react";
import { Container } from "react-bootstrap";
import about1 from "../../assets/Images/About/WhatsApp Image 2024-12-07 at 14.26.58.jpeg";
import { useIsMobile } from "../../utils/responsive";

export default function Section2() {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0">
              PIONEERING DESIGN INNOVATION AT LIVSPACE
            </h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>

      {/* Main Content Row */}
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={about1}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                objectPosition: "center 20%",
                transition: "all 0.5s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
                filter: isHovered ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>
        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            transition: "all 0.5s ease",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">In 2015,&nbsp;</span>
              she joined Livspace, a trailblazer in tech-driven interior
              solutions. Captivated by its disruptive approach, she swiftly rose
              to the leadership team, collaborating closely with the founders to
              drive strategic expansion. As Associate General Manager (Sales &
              Ops), she led high-performing teams, managed P&L, and implemented
              growth strategies that propelled the company’s rapid ascent in the
              home interiors sector.
            </p>
            <br />
            <p className="body-lg m-0">
              In 2019, at the peak of her career, Kritika Goswamy Malik was
              diagnosed with cancer—a challenge that tested her resilience.
              Forced to step back from sales, she found unwavering support from
              her peers and mentors, and her reporting leadership team who moved
              her to the Strategy Team. There, she optimized processes,
              developed a project execution playbook, and mentored designers
              through Livspace’s Learning & Development division.
            </p>
            <br />
            <p className="body-lg m-0">
              Grateful for their trust, Kritika found solace in work, which kept
              her grounded during recovery. The compassion and backing from
              founders , mentors and leadership team became a profound lesson in
              leadership and humanity, shaping her perspective on both work and
              life.
            </p>
            <br />
            <p className="body-lg m-0">
              This chapter in her journey reinforced her belief in the profound
              connection between well-designed spaces and well-being, deepening
              her commitment to crafting interiors that are not only visually
              compelling but also emotionally and physically restorative.
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
